import styled, { css } from "styled-components/macro";
import { mediaQueries } from "../styles/media.js";

const DiscountBanner = styled.div`
  display: flex;
  padding: 1em;
  font-weight: bold;
  width: auto;
  margin-bottom: 0.5em;
  ${mediaQueries.md} {
    margin-bottom: 1em;
  }

  svg {
    margin-right: 0.5em;
  }

  ${(props) =>
    props.valid &&
    css`
      color: var(--juno-color-dark-blue);
      background: var(--juno-color-very-pale-blue);
    `};

  ${(props) =>
    props.invalid &&
    css`
      color: var(--juno-color-dark-grey);
      background: var(--juno-color-off-white);
    `};
`;

export default DiscountBanner;
